import { ReactNode, SVGProps } from 'react'

export interface IconSvgProps extends SVGProps<SVGSVGElement> {
  color?: string
  width?: number | string
  height?: number | string
  children: ReactNode
}

const IconSvg = ({ color, children, ...props }: IconSvgProps) => {
  return (
    <svg
      fill={color || '#96A2C2'}
      {...props}
      width={props.width || 25}
      height={props.height || 25}
      style={{ ...props.style, minWidth: 20 }}
    >
      {children}
    </svg>
  )
}

export default IconSvg
